import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';

import { Logo, LoadingButton } from '@repo/components';
import { _deprecatedCardContent as CardContent, Card } from '@repo/components';
import { ResetPasswordForm } from '@repo/forms';
import { checkRequest } from 'src/api/authentication';
interface ResetPasswordSearch {
	id: string;
	check: string;
}

interface ResetPasswordLoaderData {
	hasRequestedReset: boolean;
}

export const Route = createFileRoute('/authentication/reset-password')({
	validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => {
		return {
			id: (search.id as string) || '',
			check: (search.check as string) || '',
		};
	},
	loaderDeps: ({ search: { id, check } }) => ({ id, check }),
	loader: async ({ deps: { id, check } }): Promise<ResetPasswordLoaderData> => {
		const hasRequestedReset = await checkRequest(id, check);
		return { hasRequestedReset };
	},
	component: ResetPassword,
});

const NoRequestedReset = () => (
	<CardContent>
		We&apos;re sorry, your request to set your password does not exist or has expired.
		<Link to="/authentication/login" search={{}} className="block mt-4 text-white underline text-sm">
			Return to login
		</Link>
	</CardContent>
);

const Success = () => (
	<CardContent>
		Your password was successfully updated!
		<LoadingButton
			className="mt-2"
			color="secondary"
			variant="outlined"
			fullWidth={true}
			onClick={() => (window.location.href = '/authentication/login')}
		>
			Click here to login
		</LoadingButton>
	</CardContent>
);

function ResetPassword() {
	const { id, check } = Route.useSearch();
	const { hasRequestedReset } = Route.useLoaderData();

	const [state, setState] = useState<'init' | 'no-request' | 'success'>(hasRequestedReset ? 'init' : 'no-request');

	return (
		<div className="bg-background flex flex-col h-screen">
			<div className="max-w-[600px] mx-auto h-full flex flex-col justify-center gap-4 p-8 pt-4 w-full items-center">
				<Logo variant="tagline" className="w-[400px] mb-8" />
				<Card>
					{state === 'init' && (
						<CardContent>
							<ResetPasswordForm
								id={id}
								check={check}
								onSuccess={() => {
									setState('success');
								}}
							/>
						</CardContent>
					)}
					{state === 'no-request' && <NoRequestedReset />}
					{state === 'success' && <Success />}
				</Card>
			</div>
		</div>
	);
}
